import React, { useState, useCallback, useEffect } from "react";
import { InputGroup, Modal, Form, Button, Spinner } from "react-bootstrap";
import axios from "axios";
import { endpoint } from "../utils/api";
import Select from 'react-select';


//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faFileImport } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faFileImport)

const FeeModal = ({ openFeeModal, setOpenFeeModal, department }) => {
  const [validated, setValidated] = useState(false);
  const [showpopover, setShowPopover] = useState(false)
  const [section, setSection] = useState([]);
  const [loading, setLoading] = useState(false);


  let doc = "";
  const getWord = async () => {
    return Word.run(async (context) => {
      const paragraph = context.document.getSelection().getOoxml();

      await context.sync();

      doc = paragraph.value;
    });
  };


  const generateFee = async () => {

        return Word.run(async (context) => {

          await axios({
            method: "post",
            url: `${endpoint}/fees/${department}/generate`, 
            data: {
                ids: ids.value,
            } ,
            headers: {
                Authorization: 'Bearer '+ localStorage.token,
                DepartmentName: department
            }
            })
            .then(function async(response) {
                console.log(response.data)
                 
                response.data.sections.map((section) => {
                        if(section.file !== null) {
                            let text = Buffer.from(section.file, 'hex').toString('utf8');
                            context.document.body.insertOoxml(text, "End")
                        }
          
                    }) 
                    context.sync();  
                    setLoading(false);
                    setOpenFeeModal(false); 
            })
            .catch((error) => {
                console.log(error)
            }) 
        }
            // response.json().then(function (data) {
            //   let text = Buffer.from(data.file, "hex").toString("utf8");
            //   context.document.getSelection().insertOoxml(text, "End");      
            //   context.sync();
            );
    }


  return (
    <Modal backdropClassName="backdrop" show={openFeeModal} onHide={() => setOpenFeeModal(false)}>
      {showpopover && <SectionPopover className="popover" /> }
      <Modal.Header className="modal-header">
        <Modal.Title >
          New Fee Proposal          
        </Modal.Title>
      </Modal.Header>

        <Modal.Body>
          <Form.Label className="bolder">IDs</Form.Label>
          <InputGroup className="mb-2">
            <Form.Control type="text" placeholder="Paste IDs..." id="ids" />
            <Form.Control.Feedback type="invalid">Please choose a name.</Form.Control.Feedback>
          </InputGroup>

         </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setOpenFeeModal(false)}>
            Close
          </Button>
          <Button className="primary-button border-button" style={{width: loading && '91px'}} onClick={() => {generateFee(); setLoading(true)}} disabled={loading}>
          {!loading ?  
                 "Generate"
          :
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    variant="light"
                />          
            }
            </Button>  
        </Modal.Footer>        
    </Modal>
    );
};

export default FeeModal;
